module.exports = __webpack_public_path__ + "static/img/QRCode.cd81e31.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/QRCode.png
// module id = esyK
// module chunks = 16